import { AdaptedGoalValues } from './adapted_goal_levels'
export {
  levelToAttributeNames,
  gradeGoalLabel,
  adaptedGoalsArrayFromSavedGoal,
  adaptedGoalOrObjectiveLevelLabelMapping,
  isSubjectELL,
  isSubjectLifeSkills
}

// these levels map to attribute names that are part of the saved goal document
const levelToAttributeNames = {
  [AdaptedGoalValues.MILD]: 'mild_goal',
  [AdaptedGoalValues.MODERATE]: 'moderate_goal',
  [AdaptedGoalValues.INTENSE]: 'intense_goal',
  grade: 'grade_level_goal',

  // alt assessment levels
  [AdaptedGoalValues.ATTENTION]: 'attention_goal',
  [AdaptedGoalValues.VISUAL]: 'visual_goal',
  [AdaptedGoalValues.HEARING]: 'hearing_goal',
  [AdaptedGoalValues.PHYSICAL]: 'physical_goal',
  [AdaptedGoalValues.EXPRESSIVE_LANGUAGE]: 'expressive_language_goal'
}

// generate the inverse mapping of levelToAttributeNames
let reverseLevelToAttributeNames = Object.keys(levelToAttributeNames).reduce((acc, level) => {
  acc[levelToAttributeNames[level]] = level
  return acc
}, {})

function isSubjectELL(subject) {
  return subject === 'English Learners'
}

function isSubjectLifeSkills(subject) {
  return (
    subject === 'Alt Academic & Life Skills' ||
    subject === 'Life Skills' ||
    subject === 'Alt Academics'
  )
}

function gradeGoalLabel(subject) {
  if (isSubjectELL(subject)) {
    return 'Advanced Level'
  }
  if (isSubjectLifeSkills(subject)) {
    return 'Core Goal'
  }
  return 'Grade Level'
}

function adaptedGoalsArrayFromSavedGoal(savedGoal) {
  let possibleAttributes = [
    'mild_goal',
    'moderate_goal',
    'intense_goal',
    'attention_goal',
    'visual_goal',
    'hearing_goal',
    'physical_goal',
    'expressive_language_goal'
  ]
  let adaptedGoals = possibleAttributes.filter(attr => savedGoal[attr]).map(attr => ({
    level: reverseLevelToAttributeNames[attr],
    text: savedGoal[attr]
  }))

  return adaptedGoals
}

const anchorObjectiveLabels = {
  [AdaptedGoalValues.FIRST]: '1st Quarter',
  [AdaptedGoalValues.SECOND]: '2nd Quarter',
  [AdaptedGoalValues.THIRD]: '3rd Quarter'
}
const defaultLevelLabels = {
  [AdaptedGoalValues.MILD]: 'Mild Level of Support',
  [AdaptedGoalValues.MODERATE]: 'Moderate Level of Support',
  [AdaptedGoalValues.INTENSE]: 'Intense Level of Support',
  ...anchorObjectiveLabels
}

const ellLevelLabels = {
  [AdaptedGoalValues.INTERMEDIATE]: 'Intermediate Level',
  [AdaptedGoalValues.BEGINNER]: 'Beginner Level',
  ...anchorObjectiveLabels
}

const lifeSkillsLevelLabels = {
  [AdaptedGoalValues.ATTENTION]: 'Attention Support',
  [AdaptedGoalValues.VISUAL]: 'Visual Support',
  [AdaptedGoalValues.HEARING]: 'Hearing Support',
  [AdaptedGoalValues.PHYSICAL]: 'Physical Support',
  [AdaptedGoalValues.EXPRESSIVE_LANGUAGE]: 'Expressive Language Support',
  ...anchorObjectiveLabels
}
function adaptedGoalOrObjectiveLevelLabelMapping(subject) {
  if (isSubjectELL(subject)) {
    return ellLevelLabels
  }
  if (isSubjectLifeSkills(subject)) {
    return lifeSkillsLevelLabels
  }
  return defaultLevelLabels
}
